import { render, staticRenderFns } from "./TopPlayersClient.vue?vue&type=template&id=b5b1d866&scoped=true"
import script from "./TopPlayersClient.vue?vue&type=script&lang=js"
export * from "./TopPlayersClient.vue?vue&type=script&lang=js"
import style0 from "./TopPlayersClient.vue?vue&type=style&index=0&id=b5b1d866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b1d866",
  null
  
)

export default component.exports